<template>
  <div class="date-locale-switcher">
    <div class="label">
      {{ $t('navBar.date') }}
    </div>
    <LocaleSelect
      :model-value="currentDateLocale"
      :items="availableFormats"
      item-title="format"
      item-value="locale"
      @update:model-value="setFormat"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useContextStore } from '@/stores/context';

const context = useContextStore();
const currentDateLocale = ref(context.getCurrentLocale);
const availableFormats = ref(context.getCurrentLocale);

const setFormat = dateLocale => {
  currentDateLocale.value = dateLocale;
  context.setDateLocale({ dateLocale });
};

const setDateFormats = () => {
  currentDateLocale.value = context.getCurrentDateLocale;
  availableFormats.value = context.getAvailableDateLocales.map(el => {
    return { locale: el, format: context.getClientConfig.dateFormats[el].long };
  });
};

setDateFormats();
</script>

<style lang="scss" scoped>
.label {
  font-size: 1.2rem;
  font-weight: normal;
  min-width: 4rem;
}

.date-locale-switcher {
  display: flex;
  align-items: center;
}
</style>
